import { Component, type ErrorInfo, type ReactNode } from 'react';

interface State { error: Error | null }

/** Last line of defence: a rendering bug shows a recoverable message instead of a blank page. */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('UI error', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh', padding: 24 }}>
        <div className="panel" style={{ maxWidth: 560, padding: 28 }}>
          <h2>Something went wrong in the interface</h2>
          <p className="muted" style={{ margin: '12px 0' }}>{this.state.error.message}</p>
          <button type="button" className="button primary" onClick={() => { this.setState({ error: null }); window.location.assign('/'); }}>Reload the workspace</button>
        </div>
      </div>
    );
  }
}
